import React, { useState, useEffect } from "react";
import { Box, Image, IconButton, Flex, Heading } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

import image1 from "../Tour/1.avif";
import image2 from "../Tour/2.avif";
import image3 from "../Tour/3.avif";
import image5 from "../Tour/5.avif";
import image6 from "../Tour/6.avif";
import image7 from "../Tour/7.avif";
import image8 from "../Tour/8.avif";
import image9 from "../Tour/9.avif";
import image10 from "../Tour/10.avif";

// Alt text doubles as image-search copy, so each shot names what it shows and
// where it is.
const images = [
  { src: image1, alt: "Dental treatment room at Qualiteeth Dental Care, Vaishali Nagar, Jaipur" },
  { src: image2, alt: "Reception desk at Qualiteeth Dental Care, Jaipur" },
  { src: image3, alt: "Dental operatory with modern equipment at Qualiteeth Dental Care" },
  { src: image5, alt: "Sterilisation area at Qualiteeth Dental Care, Jaipur" },
  { src: image6, alt: "Patient waiting lounge at Qualiteeth Dental Care, Vaishali Nagar" },
  { src: image7, alt: "Dentist treating a patient at Qualiteeth Dental Care, Jaipur" },
  { src: image8, alt: "Dental chair and treatment setup at Qualiteeth Dental Care" },
  { src: image9, alt: "Young patient with a new toothbrush after a kids dentistry visit at Qualiteeth Dental Care" },
  { src: image10, alt: "Patient at the Qualiteeth Dental Care reception in Vaishali Nagar, Jaipur" },
];

const Tour = () => {

  const [currentIndex, setCurrentIndex] = useState(0);

  // Warm the upcoming slides so each rotation is not a fresh download — see the
  // same note in HeroSection.
  useEffect(() => {
    const timer = setTimeout(() => {
      images.slice(1).forEach((slide) => {
        // createElement, not `new Image()` — `Image` here is Chakra's component.
        const img = document.createElement("img");
        img.src = slide.src;
      });
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Hold on the first slide while prerendering — see HeroSection.
    if (typeof window !== "undefined" && window.__PRERENDER__) return undefined;

    // Updater form, so the interval is created once instead of being rebuilt on
    // every slide change.
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Flex
      width="100%"
      height={{ base: "auto", md: "60vh" }}
      alignItems="center"
      justifyContent="center"
      flexDirection={{ base: "column", md: "row" }}
      bg="white"
      paddingBottom={{ base: 5 }}
      paddingTop={{ base: 5 }}
      gap={4}
    >
      <Box
        width={{ base: "100%", md: "50%" }}
        textAlign="center"
        display="flex"
        alignItems="center"
        justifyContent="center"
        height={{ base: "10%", md: "100%" }}
      >
        <Heading as="h2" fontSize={{ base: "2xl", md: "5xl" }} fontWeight="light">
          Gallery
        </Heading>
      </Box>
      <Box
        position="relative"
        width={{ base: "100%", md: "50%" }}
        height={{ base: "50%", md: "100%" }}
        overflow="hidden"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Image
          src={images[currentIndex].src}
          alt={images[currentIndex].alt}
          loading="lazy"
          maxW="90%"
          maxH="80%"
          height="400px"
          objectFit="cover"
          transition="opacity 0.5s"
          borderRadius="lg"
          boxShadow="lg"
        />
        <IconButton
          aria-label="Previous clinic photo"
          icon={<ChevronLeftIcon boxSize={6} />}
          position="absolute"
          top="50%"
          left={{ base: 2, md: 100 }}
          transform="translateY(-50%)"
          bg="blackAlpha.700"
          color="white"
          onClick={prevSlide}
          _hover={{ bg: "blackAlpha.700" }}
          borderRadius="50%"
        />
        <IconButton
          aria-label="Next clinic photo"
          icon={<ChevronRightIcon boxSize={6} />}
          position="absolute"
          top="50%"
          right={{ base: 2, md: 100 }}
          transform="translateY(-50%)"
          bg="blackAlpha.700"
          color="white"
          onClick={nextSlide}
          _hover={{ bg: "blackAlpha.700" }}
          borderRadius="50%"
        />
      </Box>
    </Flex>
  );
};

export default Tour;
